export const optionKebutuhan_1 = [
    {
        value: 'Tuna Netra',
        name: 'A. Tuna Netra'
    },
    {
        value: 'Tuna Rungu',
        name: 'B. Tuna Rungu'
    },
    {
        value: 'Tuna Grahita Ringan',
        name: 'C. Tuna Grahita Ringan'
    },
    {
        value: 'Tuna Grahita Sedang',
        name: 'C1. Tuna Grahita Sedang'
    },
    {
        value: 'Tuna Daksa Ringan',
        name: 'D. Tuna Daksa Ringan'
    },
    {
        value: 'Tuna Daksa Sedang',
        name: 'D1. Tuna Daksa Sedang'
    },
    {
        value: 'Narkoba',
        name: 'N. Narkoba'
    },
    {
        value: 'Indigo',
        name: 'O. Indigo'
    }
]

export const optionKebutuhan_2 = [
    {
        value: 'Tuna Laras',
        name: 'E. Tuna Laras'
    },
    {
        value: 'Tuna Wicara',
        name: 'F. Tuna Wicara'
    },
    {
        value: 'Hiperaktif',
        name: 'H. Hiperaktif'
    },
    {
        value: 'Cerdas Istimewa',
        name: 'I. Cerdas Istimewa'
    },
    {
        value: 'Bakat Istimewa',
        name: 'J. Bakat Istimewa'
    },
    {
        value: 'Kesulitan Belajar',
        name: 'K. Kesulitan Belajar'
    },
    {
        value: 'Down Syndrome',
        name: 'P. Down Syndrome'
    },
    {
        value: 'Autis',
        name: 'Q. Autis'
    }
]
